import React from 'react';

const SvgEc = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="EC_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="EC_svg__b" fill="#fff">
        <use xlinkHref="#EC_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#EC_svg__a" />
      <path fill="#0748AE" mask="url(#EC_svg__b)" d="M0 9.333h28v5.333H0z" />
      <path fill="#DE2035" mask="url(#EC_svg__b)" d="M0 14.667h28V20H0z" />
      <path fill="#FFD935" mask="url(#EC_svg__b)" d="M0 0h28v9.333H0z" />
      <path
        d="M12.4 8l.933 2.8h1.334L15.6 8a2.667 2.667 0 1 1-3.2 0z"
        fill="#FFD935"
        mask="url(#EC_svg__b)"
      />
      <path
        fill="#5FC0DC"
        mask="url(#EC_svg__b)"
        d="M14 7.333l.667 3.334h-1.334z"
      />
      <path
        stroke="#3F2821"
        strokeWidth={0.667}
        opacity={0.66}
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#EC_svg__b)"
        d="M17.333 6l-2-.667L14 6.667l-1.333-1.334-2 .667"
      />
    </g>
  </svg>
);

export default SvgEc;
